module.exports = __webpack_public_path__ + "img/m9.bc082c03.png";